import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WE_RIDER_LOGO_URL as weRiderLogo } from "../../services/local/institutionalBranding";
import {
  completeWeRiderAuthCallback,
  updateWeRiderPassword,
} from "../../services/supabase/weRiderService";
import useWePedidosBranding from "./useWePedidosBranding";
import "../../styles/WeRider.css";

export default function WeRiderAuthCallback() {
  useWePedidosBranding("Rider", true, weRiderLogo);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [readyForPassword, setReadyForPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    completeWeRiderAuthCallback(window.location.href)
      .then(() => {
        if (!mounted) return;
        const isRecovery =
          new URL(window.location.href).searchParams.get("mode") === "recovery";
        if (isRecovery) setReadyForPassword(true);
        else navigate("/we-pedidos/rider", { replace: true });
      })
      .catch((requestError) => {
        if (mounted) {
          setError(requestError?.message || "No pudimos confirmar tu cuenta de rider.");
        }
      });
    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handlePasswordUpdate = async (event) => {
    event.preventDefault();
    setError("");
    if (password !== confirmation) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setSaving(true);
    try {
      await updateWeRiderPassword(password);
      navigate("/we-pedidos/rider", { replace: true });
    } catch (requestError) {
      setError(requestError?.message || "No pudimos actualizar la contraseña.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="we-rider-callback-shell">
      <section className="we-rider-callback-panel">
        <img src={weRiderLogo} alt="We! Rider" />
        {readyForPassword ? (
          <form className="we-rider-form" onSubmit={handlePasswordUpdate}>
            <h1>Elegí una contraseña nueva</h1>
            <label>
              Nueva contraseña
              <input
                type="password"
                minLength={8}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>
            <label>
              Repetir contraseña
              <input
                type="password"
                minLength={8}
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                required
              />
            </label>
            {error ? <p className="we-rider-message is-error">{error}</p> : null}
            <button className="we-rider-primary" type="submit" disabled={saving}>
              {saving ? "Guardando..." : "Guardar contraseña"}
            </button>
          </form>
        ) : error ? (
          <>
            <h1>No pudimos confirmar el acceso</h1>
            <p>{error}</p>
            <a className="we-rider-primary" href="/we-pedidos/rider">Volver</a>
          </>
        ) : (
          <>
            <h1>Confirmando tu cuenta</h1>
            <p>En un momento vas a entrar al panel rider.</p>
          </>
        )}
      </section>
    </main>
  );
}
